import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadLocations = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/VisitationLog/GetGeoLocationBranchVisits', {
        Date: date,
        Key: "GetAll",
        MaxId: -1,
        Site: defaultSite.id,
        GetAll: true
    })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "GeoLocationBranchVisits");
            offlineService.addOffline(defaultSite.id, "GeoLocationBranchVisits", result);
        },
            (error) => {
                console.log(error);
            });
};

const LoadVisitationTypes = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/VisitationEVS/GetAppVisitationTypes')
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationTypes");
            offlineService.addOffline(defaultSite.id, "AppVisitationTypes", result)
        },
            (error) => {
                console.log(error);
            });
};

const LoadVisitationTemplates = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/VisitationEVS/GetAppVisitationTemplates')
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationTemplates");
            offlineService.addOffline(defaultSite.id, "AppVisitationTemplates", result);
        },
            (error) => {
                console.log(error);
            });
};

const LoadVisitationEVSDetails = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/VisitationEVS/GetAppVisitations', {
        AppVisitationId: 0,
        SiteId: defaultSite.id,
        GeoLocation: 0,
        VisitDate: date,
        RoundType: 0,
        RoundOn: 0,
        PatientName: ''
    })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "AppVisitations");
            offlineService.addOffline(defaultSite.id, "AppVisitations", result);
        },
        (error) => {
            console.log(error);
        });
};

const LoadVisitationAnswers = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/VisitationEVS/GetAppVisitationAnswers', { AppVisitation: 0 })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationAnswers");
            offlineService.addOffline(defaultSite.id, "AppVisitationAnswers", result.data);
        },
        (error) => {
            console.log(error);
        });
};

const SaveVisitationEVSOfflineData = async (siteId, entityId, keyName, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();
    let id = -1;
    let pId = -1;
    let exists = [];

    if ((entityId + "").substr(0, 1) === "$") {
        pId = parseInt(entityId.substr(1, entityId.length - 1));
        exists = await offlineSyncService.getByNameAndId(pId, keyName);
    }
    else if (entityId > 0) {
        pId = entityId;
        exists = await offlineSyncService.getByNameAndEntityId(pId, keyName);
    }

    if (!isOnline) {
        if (remove && ((entityId + "").substr(0, 1) === "$")) {
            offlineSyncService.removeById(exists.Id);
        }
        else if (entityId === 0 || !exists) {
            id = await offlineSyncService.add(siteId, pId, url, keyName, item);
        }
        else {
            offlineSyncService.updateById(exists.Id, item);
            id = exists.Id;
        }
    }

    UpdateOfflineData(siteId, item, remove);
    return id;
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "AppVisitations");
    const data = offlineResult.OfflineData.data;
    const index = data.findIndex(d => d.AppVisitationId === item.AppVisitationId);

    if (remove) {
        offlineResult.OfflineData.data.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.data.push(item);
    else {
        offlineResult.OfflineData.data[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "AppVisitations", offlineResult.OfflineData);
};

export { LoadLocations, LoadVisitationTypes, LoadVisitationTemplates, LoadVisitationEVSDetails, LoadVisitationAnswers, SaveVisitationEVSOfflineData };
